import React, { Fragment } from "react";

function CommunityListLoading({ listSize }: { listSize: number }) {
  return (
    <Fragment>
      {[...Array(listSize)].map((d, i) => {
        return (
          <div className="comunity-content" key={i}>
            <div className="comunity-skeleton-wrap">
              <div className="comunity-skeleton-wrap skeleton"></div>
            </div>
          </div>
        );
      })}
    </Fragment>
  );
}

export default CommunityListLoading;
